import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/AgendaManagement";

class EventAgendaService {
    create(data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}`,
            data, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    search(name, page) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/Search`, 
            {
                name,
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": false,
                    "targetPage": page,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    update(id, data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.put(`${BASIC_API}/${id}`,
            data, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    getDetails(id) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.get(`${BASIC_API}/${id}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    changeIsEnabled(courseId, isEnabled, name, sort = 99999) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.put(`${BASIC_API}/${courseId}`, {
            isEnabled,
            name,
            sort
        }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    // 細節頁面的章、節拖拉排序
    batchSort(courseId, requestBody) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";
        
        return axios.post(`${BASIC_API}/DetailBatchSort/${courseId}`, 
            requestBody, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    delete(companyId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.delete(`${BASIC_API}/${companyId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    uploadListImage(id, formData) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/UploadListImage/${id}`,
            formData, {
                headers: {Authorization: `Bearer ${token}`}
            }
        );
    }

    uploadHeaderImage(id, formData) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/UploadHeaderImage/${id}`,
            formData, {
                headers: {Authorization: `Bearer ${token}`}
            }
        );
    }

    submitAnswer(testQuestionId, answer, isConfident) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/SubmitAnswer.ashx`, 
            {
                testQuestionId,
                answer,
                isConfident
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    submitTest(testId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/SubmitTestPaper.ashx`, 
            {
                testId,
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    deleteNotes(questionIds) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/DeleteNote.ashx`, 
            {
                questionIds,
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
}

const NewEventAgendaService = new EventAgendaService();
export default NewEventAgendaService;